export default __webpack_public_path__ + "static/media/IMG_2146.d8045bfa.jpg";